import React, { useState , useEffect } from 'react';
import { addCommasToNumberString } from '../../../../admin/common/numberUtils';
import AddressModal from '../AddressModal'

// [hm] 입점 정보 조회(주소지 정보 획득을 위해 추가)
import { getSellerInfo } from '../../../../../api/selleradmin/productApi';

function ReturnExchange({ returnexChangeData,setReturnexChangeData })
{   
    useEffect(()=>{
        console.table(returnexChangeData);
    }, [returnexChangeData])
    
    // 사업장주소 상세 주소 
    const handleInputDetailChange = (e) => {
        const newDetail = e.target.value;
        
        const updatedDeliveryInfoData = {
            ...returnexChangeData,
            return_address: {
            ...returnexChangeData.return_address,
            detail: newDetail,
            },
        };
        
        // 수정된 데이터로 상태 업데이트
        setReturnexChangeData(updatedDeliveryInfoData);
    };
    
    
    // 반품지 변경 모달
    const [modalIsOpen, setModalIsOpen] = useState(false); //주소입력모달

    const [detailAddress, setDetailAddress] = useState(''); //상세주소
    const [detailModalState, setDetailModalState] = useState(false); //주소 입력모달 false(주소입력화면) <-> true(상세주소)
   
    useEffect(()=>{
        const updatedReturnexChangeData = {
          ...returnexChangeData,
          return_address: {
            ...returnexChangeData.return_address,
            detail: detailAddress,
          },
        };
   
        setReturnexChangeData(updatedReturnexChangeData);
    },[detailAddress])


    const onCompletePost = (data) => {
        console.table(data);

        setReturnexChangeData({
            ...returnexChangeData, // 기존 데이터 유지
            return_address: {
              ...returnexChangeData.return_address, // 기존 return_address 내용 유지
              address: data.address,
              detail: detailAddress?detailAddress:"",
              postal_code: data.zonecode,
              address_type: data.addressType === "R" ? "도로명" : "지번",
            }
        });
        
        setDetailModalState(true);
    };

    // 반품지 상세주소를 입력하지 않고 모달을 닫으면 모달 상태 초기화
    useEffect(()=>{
        if(!modalIsOpen){
            setDetailModalState(false);
        }
    },[modalIsOpen]);

    // 반품지 상세 주소까지 변경한 경우 상태 변경
    const changeAddress = () =>{
        setModalIsOpen(false);
    }

    // 초도배송비 
    const [initialDeliveryFee, setInitialDeliveryFee] = useState('');

    const handleInitialDeliveryFeeChange = (e) => {
        const newInitialDeliveryFee = e.target.value;
        setInitialDeliveryFee(newInitialDeliveryFee);
        setReturnexChangeData((prevInitialDeliveryFee) => ({
              ...prevInitialDeliveryFee,
              initial_delivery_fee: newInitialDeliveryFee
        }));
        console.log(newInitialDeliveryFee);
    };
    
    // 반품배송비 
    const [returnDeliveryFee, setReturnDeliveryFee] = useState('');
    
    const handleReturnDeliveryFeeChange = (e) => {
        const newReturnDeliveryFee = e.target.value;
        setReturnDeliveryFee(newReturnDeliveryFee);
        setReturnexChangeData((preReturnDeliveryFee) => ({
                ...preReturnDeliveryFee,
                return_delivery_fee: newReturnDeliveryFee
        }));
    };



    // [hm] 출고지, 반품지 정보 default로 입점 시 입력한 주소 자동 생성
    useEffect(() => {
        getSellerInfo()
            .then((res) => {
                // 반품지 정보 입력
                const returnAddress = res?.data?.return_address;
                if (returnAddress) {
                    setReturnexChangeData((prevData) => ({
                        ...prevData,
                        return_address: {
                            address: returnAddress.address || "",
                            detail: returnAddress.detail || "",
                            postal_code: returnAddress.postal_code || "",
                            address_type: returnAddress.address_type || "",
                        },
                    }));
                }
                console.log(returnAddress);
            })
            .catch(error => console.log(error.response.data))
    }, []);

    useEffect(() => {
        if (typeof returnexChangeData.initial_delivery_fee === 'string') {
            returnexChangeData.initial_delivery_fee = parseInt(returnexChangeData.initial_delivery_fee.replace(/,/g, ''));
        }
        if (typeof returnexChangeData.return_delivery_fee === 'string') {
            returnexChangeData.return_delivery_fee = parseInt(returnexChangeData.return_delivery_fee.replace(/,/g, ''));
        }
    }, [returnexChangeData]);

    return (
        <>
        <section className="">
            <div className='product-info'>
                <table>
                    <colgroup>
                              
                    </colgroup>
                   
                    <tbody>
                        <tr>
                            <th>반품/교환지</th>
                            <td>
                            <ul className='ec-address w-50'>
                                    <li className='d-flex'>
                                        <input type="text"
                                            placeholder="우편번호"
                                            value={returnexChangeData.return_address.postal_code}
                                            disabled 
                                        />  
                                        <button className="ms-2" 
                                                onClick={()=>setModalIsOpen(true)}>
                                                    주소 검색
                                        </button> 
                                    </li>
                                    <li>
                                        <input type="text"
                                            placeholder="사업장 주소"
                                            value={returnexChangeData.return_address.address}
                                            disabled 
                                        />   
                                    </li>
                                    <li>
                                    <input
                                        type="text"
                                        placeholder="상세주소"
                                        value={returnexChangeData.return_address.detail}
                                        onChange={handleInputDetailChange}
                                  
                                        />
                                    </li>
                                </ul>  
                                
                            </td>
                        </tr>
                        <tr>
                            <th>초도배송비(편도)<br/><span className="text-grey fs-7">상품을 구매자에게 보낼 때 판매자가 지불하는 배송비</span></th>  
                            <td className='sm-text-wrap'>
                                <input type='text'
                                        value={addCommasToNumberString(initialDeliveryFee)}
                                        onChange={handleInitialDeliveryFeeChange}
                                />
                                <span>원</span>
                            </td>
                        </tr>
                        <tr>
                            <th>반품배송비(편도)<br/><span className="text-grey fs-7">반품 받을 때 지불하는 배송비</span></th>  
                            <td className='sm-text-wrap'>
                                <input type='text'
                                       value={addCommasToNumberString(returnDeliveryFee)}
                                       onChange={handleReturnDeliveryFeeChange}
                                />
                                <span>원</span>
                            </td>
                           
                        </tr>
                        <tr>
                            <th>구매자 반품 비용</th>  
                            <td className='sm-text-wrap'>
                                <span className="text-hw">구매자의 귀책사유로 반품할 경우 받을 배송비</span><br/>
                                <span className="text-grey fs-7">무료배송 상품 반품 청구비 : (초도배송비 + 반품배송비) = {~~(initialDeliveryFee.replace(/,/g, '')) + ~~(returnDeliveryFee.replace(/,/g, ''))}원</span><br/>
                                <span className="text-grey fs-7">유료배송 상품 반품 청구비 : (반품배송비) = {returnDeliveryFee}원</span><br/>
                            </td>
                           
                        </tr>
                    </tbody>

                </table>     
            </div>

        </section>

        {/* 반품지변경 모달 */}
        {
            modalIsOpen  ? (
                <AddressModal 
                    show={modalIsOpen} 
                    onHide={setModalIsOpen} 
                    autoClose 
                    onComplete={onCompletePost} 
                    detailModalState={detailModalState} 
                    detailAddress={detailAddress} 
                    setDetailAddress={setDetailAddress} 
                    changeAddress={changeAddress}/>
            ) : null
        }
        </>
    )
}


export default ReturnExchange